<template>
  <div class="page print-info-area fs13 p20 mb-4">
    <PDFHeader :title="titleHeader"/>
    <div class="bodyPDF">
      <div class="detail-content-area table-patient-info">
        <p class="title-table">{{ $t('patient_information') }}</p>
        <div class="home-care-table">
          <table>
            <tr>
              <td>{{ $t('name') }}</td>
              <td >{{ childName }}</td>
              <td style="min-width: 250px">{{ $t('gender') }}</td>
              <td style="min-width: 127px">{{ gender }}</td>
            </tr>
            <tr>
              <td>{{ $t('age') }}</td>
              <td >{{ $tc('age_ages', age) }}</td>
              <td style="min-width: 250px">{{ $t('average_number_of_seizures_patient') }}</td>
              <td style="min-width: 127px">{{ $tc('time_times', basic_info.average_seizure ) }}</td>
            </tr>
            <tr id="list-desease-name">
              <td>{{ $t('disease_name') }}</td>
              <td class="pl-3" colspan="3">
                <ul>
                  <li v-for="(diseaseName, index) in listDisease" :key='index'>
                    {{' - ' + diseaseName}}
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <hr v-if="isShowEndLine" class="float-left w-100">
    </div>
  </div>
</template>
<script>
const HEIGHT_OF_TITLE = 36
const HEIGHT_OF_ROW = 20
import PDFHeader from './PDFHeader.vue'
import { mapState } from 'vuex'
import moment from "moment"
import { HEIGHT_OF_SPACE_AREA } from '@/js/commons/commons'
export default {
  components: {
    PDFHeader,
  },
  props: ['childName', 'titleHeader'],
  data() {
    return {
      listDisease: [],
      isShowEndLine: true,
    }
  },
  computed: {
    ...mapState({
      info: state => state.patient.info,
      basic_info: state => state.patient.basic_info,
      base: state => state.homecare.base,
    }),
    gender() {
      return this.info.gender === 0 ? this.$t('male') : this.info.gender === 1 ? this.$t('female') : this.$t('not_identify')
    },
    age() {
      return moment().diff(moment(new Date(this.info.birthday)), "years")
    },
  },
  created() {
    let self = this
    this.base.map(function(value) { 
      if (value.item_name === 'disease_name') { JSON.parse(value.answer).map(function(item) { self.listDisease.push(item.answer_value)}) }
    })
  },
  mounted() {
    let spaceArea = HEIGHT_OF_SPACE_AREA - HEIGHT_OF_TITLE
    let listElOnNewPage = []
    let indexNewPage = -1
    document.querySelectorAll('.table-patient-info tr').forEach(row => {
      if(row.id === 'list-desease-name') {
          spaceArea -= HEIGHT_OF_ROW
          document.querySelectorAll('.table-patient-info tr ul li').forEach((el, index) => {
            spaceArea -= el.offsetHeight
            if(spaceArea < 0) {
              indexNewPage++
              listElOnNewPage.push([])
              listElOnNewPage[indexNewPage].push(el.innerHTML)
              spaceArea = HEIGHT_OF_SPACE_AREA
              el.classList.add('d-none')
              this.isShowEndLine = false
            }
            else if(indexNewPage > -1) {
              listElOnNewPage[indexNewPage].push(el.innerHTML)
              el.classList.add('d-none')
              this.isShowEndLine = false
            }
          })
      }
      else {
        spaceArea-= row.offsetHeight
      }
    })
    listElOnNewPage.forEach((list, index) => {
      this.addNewPage(list, index == listElOnNewPage.length -1)
    })
  },
  methods: {
    addNewPage(listDeseaseEl, isEndLine) {
      let headerEl = document.getElementsByClassName('header')[0].outerHTML
      let newPage = document.createElement('div')
      newPage.classList.add('page', 'print-info-area', 'fs13', 'p20', 'mb-4')
      newPage.style.backgroundColor = 'white'
      newPage.style.height = '1123px'
      newPage.style.marginTop = '20px'
      newPage.innerHTML = ''
      var newEl = ''
      newEl += headerEl
      newEl += `
        <div class="bodyPDF w-100">
          <div class="detail-content-area table-patient-info">
            <div class="home-care-table">
              <table>
                <tr>
                  <td>${this.$t('disease_name')}</td>
                  <td class="pl-4" colspan="3">
                    <ul>`
      listDeseaseEl.forEach(deseaseName => newEl += `<li>${deseaseName}</li>`)
      newEl += `    </ul>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          ${isEndLine ? '<hr class="float-left w-100">' : ''}
        </div>`
      newPage.insertAdjacentHTML('beforeend', newEl)
      document.getElementsByClassName('homecare-topic-area')[0].appendChild(newPage)
    }
  }
}
</script>
<style scoped>
  .home-care-table ul li {
    line-height: 20px ;
    list-style: none;
  }
</style>